import { Route } from '@angular/router';
import { PrepareSelfComponent } from './prepare-self.component';

export const PrepareSelfRoutes: Route[] = [
  {
    path: 'prepare-self/:id',
    component: PrepareSelfComponent
  },
  {
    path: 'template-self/:id',
    component: PrepareSelfComponent
  }
];
